import { CSSProperties } from '@mui/material';
import { useState } from 'react';

import { GetDurchgangByAkaDurchgangIdOutput, VivaStatus, vivaStatus } from '../../dtos.ts';
import { freigabeWarningDialogContent } from './freigabeWarningDialogContent.ts';
import { useDurchgaengeStatusMutation } from './hooks/useDurchgaengeStatusMutation.ts';
import { PlanningWarningDialog } from './PlanningWarningDialog.tsx';
import { VivaStatusSwitch } from './VivaStatusSwitch.tsx';

type VivaStatusSwitchForDurchgangProps = {
  readonly durchgang: Pick<
    GetDurchgangByAkaDurchgangIdOutput,
    'akaDurchgangId' | 'sapStatus' | 'vivaStatus' | 'statusTransitions' | 'modultermine'
  >;
  readonly popperStyle?: CSSProperties;
};

export const VivaStatusSwitchForDurchgang = ({ durchgang, popperStyle }: VivaStatusSwitchForDurchgangProps) => {
  const [warningDialogOpen, setStatusWarningDialogOpen] = useState(false);

  const statusMutation = useDurchgaengeStatusMutation();

  const handleOnChange = (newStatus: VivaStatus) => {
    const hasManuellerAusschreibungsprozess = durchgang.modultermine.some((mt) => mt.manuellerAusschreibungsprozess);
    if (newStatus === vivaStatus.FREIGEGEBEN && hasManuellerAusschreibungsprozess) {
      setStatusWarningDialogOpen(true);
      return;
    }
    statusMutation.mutate({ newStatus, akaDurchgangIds: [durchgang.akaDurchgangId] });
  };

  const abortFreigeben = () => {
    setStatusWarningDialogOpen(false);
  };

  const confirmFreigeben = () => {
    setStatusWarningDialogOpen(false);

    statusMutation.mutate({ newStatus: vivaStatus.FREIGEGEBEN, akaDurchgangIds: [durchgang.akaDurchgangId] });
  };

  return (
    <>
      <VivaStatusSwitch
        sapStatus={durchgang.sapStatus}
        vivaStatus={durchgang.vivaStatus}
        statusTransitions={durchgang.statusTransitions}
        disabled={statusMutation.isPending}
        onChange={(newStatus) => handleOnChange(newStatus)}
        popperStyle={popperStyle}
      />

      <PlanningWarningDialog
        open={warningDialogOpen}
        warnings={[
          {
            id: freigabeWarningDialogContent.id,
            title: freigabeWarningDialogContent.title,
            message: freigabeWarningDialogContent.contentDG,
          },
        ]}
        onApprove={confirmFreigeben}
        onCancel={abortFreigeben}
        loading={statusMutation.isPending}
        approveButtonLabel={freigabeWarningDialogContent.approveButtonLabel}
        questionText={freigabeWarningDialogContent.questionText}
      />
    </>
  );
};
